module.exports = __webpack_public_path__ + "static/media/verified_user-24px.e01fa9f1.svg";